var _module_exports = "<div class=\"container\">\n  <div email-verify-popup></div>\n  <div ng-bind-html=\"faq\" class=\"support_page\"></div>\n</div>\n";;
var path = '/containers/dashboard/views/sections/support.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./js/containers/dashboard/views/sections/support.html
// module id = 720
// module chunks = 0